document.addEventListener('Searchanise.Loaded', function() {
	(function($) {
		var search_data;

		$(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
			search_data = data.items;
		});

		$(document).on('Searchanise.ResultsUpdated', function() {
			for (var i = 0; i < search_data.length; i++) {
				var element = search_data[i];
				var productEl = $('#snize-product-' + element.product_id);

				if (element.shopify_variants.length && $('.snize-color-swatch-box', productEl).length) {
					for (var k = 0; k < element.shopify_variants.length; k++) {
						var variant = element.shopify_variants[k];
						var optionColor = variant.option_color;
						var imageLink = variant.image_link ? variant.image_link : element.image_link;

						$(`.snize-color-swatch[data-value="${variant.options[optionColor]}"] span`, productEl).css('background-image', `url(${imageLink})`);
					}
				}
			}
			$('.snize-search-results .snize-product').each(function() {
				var snizeCurrentProduct = $(this);
				if ($('.snize-color-swatch', snizeCurrentProduct).length > 3 && !$('.snize-color-swatches-show-more', snizeCurrentProduct).length) {
					$('.snize-color-swatch-box', snizeCurrentProduct).append(`<span class="snize-color-swatches-show-more">+${$('.snize-color-swatch', snizeCurrentProduct).length - 3}</span>`);
					$('.snize-color-swatches-show-more', snizeCurrentProduct).on('click', function(e) {
						e.preventDefault();
						$('.snize-color-swatch', snizeCurrentProduct).css('display', 'inline-block');
						$('.snize-color-swatches-show-more', snizeCurrentProduct).remove();
					})
				}
			});
		});
	})(window.Searchanise.$);
});